import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";


// OBTENER LISTA CORREOS - SCREEN PRINCIPAL
export const getListaCorreos = async () => {
    const respuesta = await PrivateInterceptor(`Base/IT/ListaCorreo`, "GET");
    return respuesta;
};

// GUARDAR LISTA DE CORREOS - CRUD
export const GuardarListaCorreos = (Datos) => {
    const respuesta = PrivateInterceptor("Base/IT/ListaCorreo/AgregarListaCorreos", "POST", {Datos});
    return respuesta;
};

// GUARDAR LISTA DE CORREOS - CRUD
export const EditarListaCorreos = (Datos) => {
    const respuesta = PrivateInterceptor("Base/IT/ListaCorreo/EditarListaCorreos", "POST", {Datos});
    return respuesta;
};


// GUARDAR LISTA DE CORREOS - CRUD
export const EliminarListaCorreos = (Datos) => {
    const respuesta = PrivateInterceptor("Base/IT/ListaCorreo/EliminarListaCorreos", "POST", {Datos});
    return respuesta;
};

export const getCorreosCliente = async(Token) => {
    const result = await PublicInterceptor('Base/IT/ListaCorreo/CorreoClientes/token', 'GET', {}, Token)
    return result;
}

  
// // OBTENER LA TASA DE CAMBIO DEL MES ACTUVO 
// export const getTasaCambio = async () => {
//     const respuesta = await PrivateInterceptor(`CalendarioOperativo/CalendarioMensual/TasaCambioMesActivo`, "GET");
//     return respuesta;
// };

// // EDITAR CALENDARIO MENSUAL
// export const EditarCalendarioMensual = (datos, datosSemanas) => {
//     const respuesta = PrivateInterceptor("CalendarioOperativo/CalendarioMensual/EditarCalendarioMensual", "POST", {datos, datosSemanas});
//     return respuesta;
// };
